{
	"title": "Библиотека",
	"subtitle": "Все загруженные материалы",
	"add": "Добавить",
	"segments": {
		"all": "Все {count}",
		"notInCourse": "Без курса {count}",
		"noFolder": "Без папки {count}"
	},
	"filters": {
		"search": "Поиск по материалам",
		"type": "Тип",
		"anyType": "Любой тип",
		"folder": "Папка",
		"reset": "Сбросить фильтры"
	},
	"folders": {
		"title": "Папки",
		"all": "Все",
		"noFolder": "Без папки",
		"create": "＋ Новая папка",
		"createTitle": "Новая папка",
		"nameLabel": "Название",
		"namePlaceholder": "Например, Лекции",
		"colorLabel": "Цвет",
		"submit": "Создать",
		"cancel": "Отмена",
		"created": "Папка создана",
		"createError": "Не удалось создать папку",
		"rename": "Переименовать",
		"renamed": "Папка переименована",
		"renameError": "Не удалось переименовать папку",
		"delete": "Удалить папку",
		"deleteConfirmTitle": "Удалить папку?",
		"deleteConfirmDescription": "Папка «{name}» будет удалена. Материалы останутся в библиотеке.",
		"deleted": "Папка удалена",
		"deleteError": "Не удалось удалить папку",
		"itemsCount": "{count, plural, one {# материал} few {# материала} many {# материалов} other {# материалов}}",
		"empty": "Папок пока нет",
		"pick": "Папка",
		"open": "Открыть папку",
		"actions": "Действия с папкой",
		"openBanner": "Открыть папку «{name}»",
		"pageDescription": "Откройте папку, чтобы создать заметку, карточки или тест на основе всех содержащихся в ней материалов",
		"emptyTitle": "Папок пока нет",
		"emptyHint": "Создайте папку для группировки материалов, чтобы генерировать заметки, карточки или тесты сразу по всем файлам",
		"materialsCount": "{count, plural, one {# материал} few {# материала} many {# материалов} other {# материала}}",
		"searchPlaceholder": "Поиск папок",
		"loadError": "Не удалось загрузить папки",
		"emptyFiltered": "По вашему запросу папок не найдено",
		"sort": {
			"label": "Сортировка",
			"default": "Порядок в библиотеке",
			"name": "По названию",
			"materials": "По количеству материалов"
		}
	},
	"card": {
		"inCourses": "{count, plural, one {в # курсе} few {в # курсах} many {в # курсах} other {в # курсах}}",
		"notInCourse": "Без курса",
		"noFolder": "Без папки",
		"open": "Открыть"
	},
	"selection": {
		"enter": "Выбрать",
		"exit": "Отменить",
		"count": "Выбрано {count}",
		"toCourse": "В курс",
		"toFolder": "В папку",
		"delete": "Удалить",
		"selectAll": "Выбрать все",
		"pickCourse": "Выбери курс",
		"pickFolder": "Выбери папку",
		"newCourse": "＋ Новый курс",
		"removeFromFolder": "Убрать из папки",
		"addedToCourse": "{count, plural, one {# материал} few {# материала} many {# материалов} other {# материалов}} → {course}",
		"openCourse": "Открыть курс",
		"addToCourseError": "Не удалось добавить в курс",
		"movedToFolder": "{count, plural, one {Перемещён # материал} few {Перемещено # материала} many {Перемещено # материалов} other {Перемещено # материалов}}",
		"moveToFolderError": "Не удалось переместить в папку",
		"hintTouch": "Задержи палец на карточке, чтобы выбрать несколько",
		"hintDesktop": "Shift — диапазон, Cmd/Ctrl — точечно"
	},
	"empty": {
		"library": {
			"title": "Библиотека пуста",
			"description": "Загрузи первый материал — лекцию, главу учебника или запись.",
			"cta": "Загрузить материал"
		},
		"filter": {
			"title": "Под фильтр ничего не подошло",
			"description": "Измени запрос, тип или папку.",
			"cta": "Сбросить фильтры"
		},
		"notInCourse": {
			"title": "Всё разложено по курсам",
			"description": "Материалов вне курсов не осталось."
		},
		"folder": {
			"title": "Папка пуста",
			"description": "Перенеси сюда материалы или загрузи новые.",
			"upload": "Загрузить",
			"pickExisting": "Выбрать существующие"
		}
	},
	"errors": {
		"loadFailed": "Не удалось загрузить библиотеку",
		"retry": "Повторить"
	},
	"picker": {
		"title": "Выбрать материалы",
		"description": "Ищи по всей библиотеке, фильтруй по папке.",
		"submit": "Добавить",
		"cancel": "Отмена",
		"selected": "Выбрано {count}",
		"empty": "Нечего выбрать"
	},
	"addTo": {
		"trigger": "Добавить в папку",
		"title": "Сохранить в папку",
		"loading": "Загрузка папок…",
		"empty": "У вас еще нет папок. Создайте первую, и этот элемент будет добавлен в нее.",
		"errorTitle": "Не удалось загрузить папки",
		"retry": "Повторить",
		"createSection": "Создать папку",
		"createPlaceholder": "Название папки",
		"createCta": "Создать",
		"creating": "Создаём…",
		"added": "Добавлено в «{name}»",
		"removed": "Убрано из «{name}»",
		"toggleError": "Не удалось обновить папку",
		"createError": "Не удалось создать папку",
		"itemChecked": "Элемент находится в папке «{name}»",
		"itemUnchecked": "Элемент не находится в папке «{name}»"
	},
	"detail": {
		"collectionLabel": "Папка",
		"back": "К папкам",
		"sectionMaterials": "Материалы",
		"sectionMaterialsHint": "Материалы в папке и артефакты, созданные на их основе",
		"sectionSetWide": "Для всей папки",
		"sectionSetWideHint": "Артефакты, созданные на основе всей папки",
		"sectionStandalone": "Отдельные элементы",
		"sectionStandaloneHint": "Добавлено в папку напрямую",
		"groupArtifactsToggle": "{count, plural, one {# артефакт} few {# артефакта} many {# артефактов} other {# артефакта}}",
		"emptyTitle": "Папка пуста",
		"emptyDescription": "Добавь материалы или артефакты, чтобы собрать их в одном месте.",
		"openMaterial": "Открыть материал",
		"generatePlan": "Сгенерировать учебный план",
		"generatePlanStarted": "Создание плана обучения из папки…",
		"generatePlanError": "Не удалось создать учебный план",
		"notFound": "Папка не найдена",
		"loadFailed": "Не удалось загрузить папку",
		"syncPending": "Ожидаем синхронизацию",
		"retry": "Повторить"
	},
	"generate": {
		"sectionTitle": "Создать из всей папки",
		"sectionHint": "ИИ создаст единый артефакт на основе всех материалов в папке",
		"notes": "Заметки по папке",
		"flashcards": "Карточки по папке",
		"quiz": "Тест по папке",
		"regenerate": "Перегенерировать",
		"open": "Открыть",
		"generating": "Генерируется…",
		"started": "Запущена генерация — артефакт появится здесь",
		"failed": "Не удалось сгенерировать. Попробуй ещё раз",
		"noMaterials": "Добавьте материалы в папку для создания артефактов",
		"staleBadge": "Папка изменена",
		"staleHint": "Содержимое папки изменилось после создания — обновите артефакт",
		"confirmTitle": "Создать из всей папки",
		"confirmDescription": "Будут использованы все {count, plural, one {# материал} few {# материала} many {# материалов} other {# материала}} в папке.",
		"confirmQuota": "Это спишет примерно {units, plural, one {# единицу} few {# единицы} many {# единиц} other {# единицы}} AI-квоты.",
		"confirmCancel": "Отмена",
		"confirmStart": "Создать",
		"studyPlan": "Учебный план",
		"studyPlanHint": "Пошаговый план обучения на основе материалов папки",
		"planConfirmTitle": "Создать учебный план?",
		"planConfirmDescription": "ИИ составит пошаговый план обучения на основе {count, plural, one {# материала} few {# материалов} many {# материалов} other {# материала}} в этой папке. Это объемная генерация, которая может занять до минуты.",
		"planConfirmQuota": "Спишется 1 единица AI-квоты.",
		"planConfirmCancel": "Отмена",
		"planConfirmStart": "Создать план"
	},
	"chat": {
		"askAi": "Спросить ИИ о папке",
		"voice": "Голосовой разбор папки",
		"contextBadge": "Контекст: папка «{name}»",
		"pickCollection": "По папкам",
		"pickMaterials": "По материалам",
		"pickPlaceholder": "Без папки",
		"pickSearch": "Поиск папки…",
		"pickNone": "Без папки"
	},
	"artifact": {
		"type": {
			"material": "Материал",
			"test": "Тест",
			"flashcard_set": "Карточки",
			"note": "Конспект",
			"audio_recap": "Аудио-резюме",
			"visual_analysis": "Объяснение по фото",
			"essay": "Эссе"
		},
		"open": "Открыть",
		"publish": {
			"make": "Сделать публичным",
			"public": "Публичный",
			"private": "Приватный",
			"toggleAria": "Публикация артефакта",
			"madePublic": "Артефакт опубликован",
			"madePrivate": "Публикация снята",
			"error": "Не удалось изменить публикацию",
			"hint": "Публичные артефакты отображаются в списке материалов папки"
		}
	},
	"testsFilter": {
		"label": "Папка",
		"all": "Все папки",
		"placeholder": "Фильтр по папке",
		"empty": "Нет папок",
		"search": "Поиск папки…",
		"clear": "Сбросить фильтр"
	},
	"addMenu": {
		"trigger": "Добавить",
		"menuTitle": "Добавить в папку",
		"uploadNew": "Загрузить новый материал",
		"pickExisting": "Выбрать существующие"
	},
	"upload": {
		"successToCollection": "Добавлено в папку",
		"membershipBadge": "{count, plural, one {в # папке} few {в # папках} many {в # папках} other {в # папке}}",
		"membershipOne": "В папке"
	},
	"artifactPicker": {
		"title": "Выбрать существующие",
		"description": "Добавь материалы, отдельные артефакты и артефакты из чата с AI. Привязанные к обычному материалу скрыты — добавь сам материал, и они появятся вместе с ним.",
		"tabs": {
			"material": "Материалы",
			"flashcard_set": "Карточки",
			"test": "Тесты",
			"note": "Конспекты",
			"audio_recap": "Аудио-резюме",
			"visual_analysis": "Визуальные",
			"essay": "Эссе"
		},
		"loading": "Загрузка…",
		"errorTitle": "Не удалось загрузить",
		"retry": "Повторить",
		"empty": "Нет отдельных элементов этого типа",
		"emptyHint": "Здесь — артефакты без материала и созданные из чата. Остальные добавляй через таб «Материалы».",
		"goToMaterials": "Перейти к материалам",
		"standaloneCount": "{count, plural, one {# элемент без обычного материала} few {# элемента без обычного материала} many {# элементов без обычного материала} other {# элемента без обычного материала}}",
		"fromChat": "из чата «{name}»",
		"fromChatFallback": "чат",
		"noMatches": "Ничего не найдено",
		"search": "Поиск…",
		"selectedCount": "{count, plural, one {Выбран # элемент} few {Выбрано # элемента} many {Выбрано # элементов} other {Выбрано # элементов}}",
		"cancel": "Отмена",
		"add": "Добавить",
		"addCount": "Добавить ({count})",
		"added": "{count, plural, one {Добавлен # элемент} few {Добавлено # элемента} many {Добавлено # элементов} other {Добавлено # элементов}}",
		"addedWithChat": "Добавлено. Артефакты из чата попали через материал диалога.",
		"addError": "Не удалось добавить в папку",
		"limitReached": "Можно добавить не больше {limit} элементов за раз"
	},
	"share": {
		"trigger": "Поделиться",
		"dialogTitle": "Поделиться папкой",
		"dialogDescription": "Откройте доступ к папке по ссылке.",
		"publicExplain": "Папка и все её материалы станут доступны любому, у кого есть ссылка — только для чтения. Артефакты останутся приватными.",
		"makePublic": "Сделать публичной",
		"isPublicTitle": "Папка доступна по ссылке",
		"isPublicHint": "Любой, у кого есть ссылка, может видеть папку и её материалы.",
		"linkLabel": "Ссылка на папку",
		"copy": "Скопировать ссылку",
		"copied": "Ссылка скопирована",
		"revoke": "Закрыть доступ",
		"revoked": "Доступ закрыт",
		"made": "Папка опубликована",
		"error": "Не удалось изменить доступ",
		"done": "Готово"
	},
	"dock": {
		"addToCollection": "Добавить в папку",
		"dropTitle": "Перетащите в папку",
		"added": "Добавлено в папку",
		"newCollection": "Новая папка",
		"pick": "Выберите папку",
		"pickTitle": "Добавить в папку",
		"pickSearch": "Поиск папок…",
		"pickEmpty": "Папок пока нет",
		"more": "Ещё {count}",
		"dropHere": "Бросьте сюда",
		"emptyHint": "Перетащите сюда, чтобы создать свою первую папку",
		"createError": "Не удалось создать папку",
		"addError": "Не удалось добавить в папку"
	},
	"addArtifact": {
		"title": "Что добавить в папку?",
		"wholeMaterial": "Добавить весь материал «{material}»",
		"wholeMaterialHint": "Вместе со всеми его конспектами, тестами и карточками",
		"copy": "Создать независимую копию: {type}",
		"copyHint": "Только этот {type}, отдельно от материала",
		"materialAdded": "Материал добавлен в папку",
		"copied": "Скопировано в папку",
		"copying": "Копируется…",
		"copyReady": "Копия добавлена в папку",
		"copyFailed": "Не удалось создать копию",
		"error": "Не удалось добавить в папку"
	},
	"intro": {
		"title": "Библиотека — это исходники",
		"body": "Здесь лежит всё, что вы загрузили: файлы, ссылки, тексты. Конспекты, тесты и карточки — производные от них, у них свои разделы.",
		"bullets": [
			"Один источник живёт сразу в нескольких папках и курсах",
			"Фильтр покажет, что не попало ни в один курс",
			"Папку целиком можно отправить в курс"
		]
	}
}
